import { render, staticRenderFns } from "./Faqs.vue?vue&type=template&id=f276080a"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports